exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/components/Elements/LoggedOutInfoMessage/LoggedOutInfoMessage.less
 ** module id = 1056
 ** module chunks = 0
 **/